import { makeStyles } from "@material-ui/core"
import splashImage from '../assets/images/splashPage.jpg'
import { Typography, ButtonBase, Paper, TextField } from '@material-ui/core'
import React, { useState } from "react"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom"
import { useAppAuth } from "../auth/app-auth"
import { isAuthDisabled } from "../config/env"


const useStyles = makeStyles(theme => {
  return {
    container: {
      backgroundImage: `url(${splashImage})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      height: '75vh',
      display: 'flex',
      flexDirection: 'row', 
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      width: '100%'
    },
    titleField: {
      color: '#fff',
      marginBottom: '50px',
      textTransform: 'uppercase',
      fontWeight: 'bold'
    },
    overlay: {
      minWidth: '500px',
      padding: '50px',
      background: "rgba(0, 8, 39, 0.5)",
      borderRadius: '10px'
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      minWidth: 320,
    },
    input: {
      "& .MuiInputBase-root": {
        color: "#fff",
      },
      "& .MuiInputLabel-root": {
        color: "rgba(255,255,255,0.8)",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255,255,255,0.35)",
      },
    },
    errorText: {
      color: "#ffb4b4",
      minHeight: theme.spacing(3),
    },
    loginButton: {
      color: '#fff'
    },
    loginButtonOuter: {
      color: '#fff',
      padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
      border: '4px solid transparent',
      textTransform: 'uppercase'
    },
    loginButtonMarked: {
      height: 3,
      width: 18,
      backgroundColor: '#fff',
      position: 'absolute',
      bottom: 0,
      left: 'calc(50% - 9px)',
      transition: theme.transitions.create('opacity'),
    },
    focusVisible: {},
    loginBase: {
      '&:hover, &$focusVisible': {
        zIndex: 1,
        '& $imageBackdrop': {
          opacity: 0.15,
        },
        '& $loginButtonMarked': {
          opacity: 0,
        },
        '& $loginButtonOuter': {
          border: '4px solid #fff',
        },
      }
    }
  }
})


const PublicHomePage = (props) => {
  const styles = useStyles()
  const history = useHistory();
  const { login, isLoading } = useAppAuth()
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submitHandler = async () => {
    const result = await login(username, password);

    if (!result.success) {
      setError(result.message || "Unable to login");
      return;
    }

    setError("");
    history.push("/dashboard");
  };

  return (
    <div className={styles.container}>
      <Paper elevation={0} className={styles.overlay}>
        <Typography className={styles.titleField} variant='h3' align='center'>    
          The Board Shield
        </Typography>
        {isAuthDisabled ? (
          <ButtonBase
            focusRipple
            focusVisibleClassName={styles.focusVisible}
            className={styles.loginBase}
            component={Link}
            to="/dashboard"
          >
            <span className={styles.loginButtonOuter}>
              <Typography component='span' variant='subtitle1' className={styles.loginButtonInner}>
                Enter
                <span className={styles.loginButtonMarked}/>
              </Typography>
            </span>
          </ButtonBase>
        ) : (
          <div className={styles.form}>
            <TextField
              label="Email"
              variant="outlined"
              className={styles.input}
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="email"
            />
            <TextField
              label="Password"
              type="password"
              variant="outlined"
              className={styles.input}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  submitHandler();
                }
              }}
            />
            <Typography variant="body2" className={styles.errorText}>
              {error}
            </Typography>
            <ButtonBase
              focusRipple
              focusVisibleClassName={styles.focusVisible}
              className={styles.loginBase}
              onClick={submitHandler}
              disabled={isLoading}
            >
              <span className={styles.loginButtonOuter}>
                <Typography component='span' variant='subtitle1' className={styles.loginButtonInner}>
                  {isLoading ? "Signing In" : "Login"}
                  <span className={styles.loginButtonMarked}/>
                </Typography>
              </span>
            </ButtonBase>
          </div>
        )}
      </Paper>
    </div>
  );
}

export default PublicHomePage
